import lockDeskApi from '../services/lockDeskApi';

const POLL_INTERVAL_MS = 60000;

/**
 * Current Lock Desk status, kept in sync via polling and RTK Query tag
 * invalidation (the admin toggle invalidates "LockDesk").
 *
 * Fails open — if the status hasn't loaded (or the endpoint errors) locking
 * stays available so a transient outage never blocks the lock flow.
 */
const useLockDeskStatus = () => {
  const { data, isLoading, isError } = lockDeskApi.endpoints.getLockDeskStatus.useQuery(undefined, {
    pollingInterval: POLL_INTERVAL_MS,
  });

  const status = data ?? { isEnabled: true, reason: null, updatedAt: null, updatedBy: null };
  return {
    isLockDeskEnabled: isError ? true : status.isEnabled,
    lockDeskStatus: status,
    isLockDeskStatusLoading: isLoading,
  };
};

export default useLockDeskStatus;
